import React, { useState, useEffect } from 'react';
import { Gift, X, Copy, Check } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';
import { markMilestoneShown } from '../../utils/referralTriggers';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

export default function ReferralMilestoneCard({ milestone, onDismiss }) {
  const { isDarkMode } = useTheme();
  const [refLink, setRefLink] = useState('');
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!milestone) return;
    const token = localStorage.getItem('token');
    if (!token) return;
    fetch(`${API_BASE}/api/affiliate/my-code`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d?.ref_link) setRefLink(d.ref_link); })
      .catch(() => {});
  }, [milestone]);

  const copyLink = () => {
    if (!refLink) return;
    navigator.clipboard.writeText(refLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleDismiss = () => {
    markMilestoneShown(milestone);
    onDismiss?.();
  };

  if (!milestone) return null;

  return (
    <div
      className="mt-8"
      style={{
        background: isDarkMode
          ? 'linear-gradient(135deg, #064e3b 0%, #065f46 100%)'
          : 'linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)',
        border: isDarkMode ? '1px solid #065f46' : '1px solid #6ee7b7',
        borderRadius: 16,
        padding: '20px 24px',
        position: 'relative',
      }}
    >
      <button
        onClick={handleDismiss}
        style={{
          position: 'absolute', top: 12, right: 12,
          background: 'none', border: 'none', cursor: 'pointer',
          color: isDarkMode ? '#6ee7b7' : '#059669', padding: 4, borderRadius: 6, lineHeight: 0,
        }}
        aria-label="Dismiss"
      >
        <X size={16} />
      </button>

      <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
        <div style={{
          width: 40, height: 40, borderRadius: 12, flexShrink: 0,
          background: 'linear-gradient(135deg, #10b981, #059669)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <Gift size={20} color="#fff" />
        </div>
        <div style={{ flex: 1 }}>
          <p style={{
            color: isDarkMode ? '#d1fae5' : '#065f46',
            fontSize: 15, fontWeight: 700, margin: '0 0 4px',
          }}>
            You've translated {milestone.toLocaleString()} words this month! 🎉
          </p>
          <p style={{ color: isDarkMode ? '#6ee7b7' : '#059669', fontSize: 13, margin: '0 0 12px' }}>
            Share t09n.com and earn ₹500 when a colleague subscribes to any paid plan.
          </p>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
            <button
              onClick={copyLink}
              disabled={!refLink}
              style={{
                display: 'flex', alignItems: 'center', gap: 6,
                background: isDarkMode ? '#10b981' : '#059669',
                color: '#fff', border: 'none', borderRadius: 8,
                padding: '7px 14px', fontSize: 13, fontWeight: 600,
                cursor: refLink ? 'pointer' : 'not-allowed',
                opacity: refLink ? 1 : 0.6,
              }}
            >
              {copied ? <Check size={14} /> : <Copy size={14} />}
              {copied ? 'Copied!' : 'Copy Referral Link'}
            </button>
            {refLink && (
              <span style={{
                fontSize: 11, fontFamily: 'monospace',
                color: isDarkMode ? '#6ee7b7' : '#047857',
                wordBreak: 'break-all',
              }}>
                {refLink}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
